export const OAUTH_CALLBACK = '/oauth/callback';
